/** @format */

import styled from "styled-components";
// import bgImage from "../assets/bgIMG.png";

const HeaderWrap = styled.div`
  .bold-text {
    color: ${(p) => p.theme.app__whitebg};
  }

  #home {
    position: relative;
  }
  #home .app__wrapper {
    padding: 0;
  }
  #home .app__wrapper .copyright {
    display: none;
  }
  .app__header {
    flex: 1;
    width: 100%;
    height: 100%;
    flex-direction: row;
    padding: 6rem 2rem 0;
  }
  @media screen and (min-width: 2000px) {
    .app__header {
      padding-top: 8rem;
    }
  }
  @media screen and (max-width: 1200px) {
    .app__header {
      flex-direction: column;
    }
  }
  @media screen and (max-width: 450px) {
    .app__header {
      padding: 6rem 1rem 2rem;
    }
  }
  .app__header-info {
    flex: 0.65;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    height: 100%;
  }
  @media screen and (max-width: 2000px) {
    .app__header-info {
      width: 100%;
      margin-right: 0;
    }
  }
  .app__header-badge {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    flex-direction: column;
  }
  .app__header-badge .badge-cmp,
  .app__header-badge .tag-cmp {
    padding: 1rem 2rem;
    border: ${(p) => p.theme.primaryColor};

    border-radius: 15px;
    flex-direction: row;
    width: auto;
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    background-color: ${(p) => p.theme.app__headerbadge};
    color: ${(p) => p.theme.app__textp};
  }
  .app__header-badge .tag-cmp {
    flex-direction: column;
    margin-top: 3rem;
  }
  .app__header-badge .tag-cmp p {
    width: 100%;
    text-transform: uppercase;
    text-align: right;
  }
  .app__header-badge span {
    font-size: 2.5rem;
  }
  @media screen and (min-width: 2000px) {
    .app__header-badge span {
      font-size: 5rem;
    }
  }
  @media screen and (max-width: 1200px) {
    .app__header-badge {
      justify-content: flex-start;
      align-items: flex-start;
    }
  }
  .app__header-circles {
    flex: 0.75;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: flex-start;
    height: 100%;
    margin-left: 1rem;
  }
  .app__header-circles div {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    background: ${(p) => p.theme.aboutCirclesColor};
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
  }
  .app__header-circles div img {
    width: 60%;
    height: 60%;
  }
  .app__header-circles div:nth-child(1) {
    width: 100px;
    height: 100px;
  }
  .app__header-circles div:nth-child(2) {
    margin: 1.75rem;
    width: 150px;
    height: 150px;
  }
  .app__header-circles div:nth-child(3) {
    width: 70px;
    height: 70px;
  }
  @media screen and (min-width: 2000px) {
    .app__header-circles div:nth-child(1) {
      width: 400px;
      height: 400px;
    }
    .app__header-circles div:nth-child(2) {
      margin: 1.75rem;
      width: 170px;
      height: 170px;
    }
    .app__header-circles div:nth-child(3) {
      width: 200px;
      height: 200px;
    }
  }
  @media screen and (max-width: 1200px) {
    .app__header-circles {
      width: 100%;
      flex-direction: row;
      flex-wrap: wrap;
      margin-left: 0;
    }
    .app__header-circles div {
      margin: 1rem;
    }
  }
  .app__header-img {
    flex: 1;
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    position: relative;
  }
  .app__header-img img {
    width: 100%;
    object-fit: contain;
    z-index: 1;
  }
  .app__header-img .overlay_circle {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    width: 100%;
    height: 90%;
  }
  @media screen and (max-width: 1200px) {
    .app__header-img {
      margin: 2rem 0;
    }
  }
`;

export default HeaderWrap;
